import { gql } from 'graphql-request';

export default gql`query($filter: PhotometricInput) {
  photometricConfig(filter: $filter) {
    product_id
    product_version_id
    diode_id
    power
    cri_id
    color_temperature_id
    luminaire_config_id
    luminous_flux
    lens_id
    led_module_id
    diode_quantity
    mounting_id
  }
}`;